import {all, call, fork, put, takeEvery} from 'redux-saga/effects'

import axios from 'axios'

import {SIGNIN_USER, SIGNOUT_USER} from 'constants/ActionTypes'
import {
  showAuthMessage,
  userSignInSuccess,
  userSignOutSuccess,
} from '../../appRedux/actions/Auth'


const AUTH_TOKEN = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJoZWFkZXIiOnsiaWQiOiIwIiwidXNlciI6Ik1hbnVlbEdpbCJ9LCJwYXlsb2FkIjp7ImlhdCI6IjIwMTktMDEtMDEgMDA6MDA6MDAiLCJleHAiOiIyMDIwLTAxLTAxIDAwOjAwOjAwIn19.p_PtmXsDe3l_osPEzb4edkf-M2SCdUVBQBKs8ZAbpn8'
const signInUserWithEmailPasswordRequest = async (email, password) =>

      axios({
        method: 'post',
        url: 'https://admingreenerapp.crsostenible.com/api/public/api/app/login/admin',
        data: {
          email: email,
          password: password
        },
        headers:{
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + AUTH_TOKEN
        }
      })
    .then(function(response){
      if(response.data.loggedIn==1){
        return response.config.data;
      }
    })
    .catch(error => error)

function* signInUserWithEmailPassword({payload}) {
  const {email, password} = payload
  try {
    const signInUser = yield call(
      signInUserWithEmailPasswordRequest,
      email,
      password,
    )
    if (signInUser == undefined) {
      yield put(showAuthMessage('Error en la validación de los datos.'))
    } else {
      localStorage.setItem('user_id', 1)
      yield put(userSignInSuccess(signInUser)) // .data.result.id
    }
  } catch (error) {
    yield put(showAuthMessage(error))
  }
}

function* signOut() {
  try {
    const signOutUser = undefined //yield call(signOutRequest);
    if (signOutUser === undefined) {
      localStorage.removeItem('user_id')
      localStorage.clear()
      yield put(userSignOutSuccess(signOutUser))
    } else {
      yield put(showAuthMessage(signOutUser.message))
    }
  } catch (error) {
    yield put(showAuthMessage(error))
  }
}

export function* signInUser() {
  yield takeEvery(SIGNIN_USER, signInUserWithEmailPassword)
}

export function* signOutUser() {
  yield takeEvery(SIGNOUT_USER, signOut)
}

export default function* rootSaga() {
  yield all([fork(signInUser), fork(signOutUser)])
}



// WEBPACK FOOTER //
// ./src/appRedux/sagas/Auth.js